export const accountZh = {
  title: '账户设置',
  tabs: {
    password: '修改密码',
    email: '邮箱管理',
  },
  password: {
    hint: '定期修改密码有助于保障账户安全',
    currentPassword: '当前密码',
    currentPasswordPlaceholder: '请输入当前密码',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码（6-30位）',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    nextStep: '下一步',
    verifyTitle: '邮箱验证',
    verifyDesc: '验证码已发送至 {email}',
    verifyCode: '验证码',
    verifyCodePlaceholder: '请输入验证码',
    getCode: '获取验证码',
    countdown: '{n}s',
    confirmChange: '确认修改',
    notAvailable: '密码修改功能暂未开放，请联系管理员',
  },
  email: {
    currentEmail: '当前邮箱：{email}',
    bound: '已绑定',
    newEmail: '新邮箱地址',
    newEmailPlaceholder: '请输入新邮箱地址',
    verifyCode: '验证码',
    verifyCodePlaceholder: '请输入验证码',
    getCode: '获取验证码',
    countdown: '{n}s',
    confirmChange: '确认换绑',
    notAvailable: '邮箱换绑功能暂未开放，请联系管理员',
  },
}

export const accountEn = {
  title: 'Account Settings',
  tabs: {
    password: 'Change Password',
    email: 'Email Management',
  },
  password: {
    hint: 'Changing your password regularly helps keep your account secure',
    currentPassword: 'Current Password',
    currentPasswordPlaceholder: 'Enter current password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Enter new password (6–30 characters)',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Re-enter new password',
    nextStep: 'Next',
    verifyTitle: 'Email Verification',
    verifyDesc: 'Verification code sent to {email}',
    verifyCode: 'Verification Code',
    verifyCodePlaceholder: 'Enter verification code',
    getCode: 'Get Code',
    countdown: '{n}s',
    confirmChange: 'Confirm Change',
    notAvailable: 'Password change is not available yet. Please contact your administrator.',
  },
  email: {
    currentEmail: 'Current email: {email}',
    bound: 'Verified',
    newEmail: 'New Email Address',
    newEmailPlaceholder: 'Enter new email address',
    verifyCode: 'Verification Code',
    verifyCodePlaceholder: 'Enter verification code',
    getCode: 'Get Code',
    countdown: '{n}s',
    confirmChange: 'Confirm Change',
    notAvailable: 'Email change is not available yet. Please contact your administrator.',
  },
}

export const accountJa = {
  title: 'アカウント設定',
  tabs: {
    password: 'パスワード変更',
    email: 'メール管理',
  },
  password: {
    hint: '定期的なパスワード変更はアカウントの安全に役立ちます',
    currentPassword: '現在のパスワード',
    currentPasswordPlaceholder: '現在のパスワードを入力',
    newPassword: '新しいパスワード',
    newPasswordPlaceholder: '新しいパスワードを入力（6〜30文字）',
    confirmPassword: 'パスワード確認',
    confirmPasswordPlaceholder: '新しいパスワードを再入力',
    nextStep: '次へ',
    verifyTitle: 'メール認証',
    verifyDesc: '認証コードを {email} に送信しました',
    verifyCode: '認証コード',
    verifyCodePlaceholder: '認証コードを入力',
    getCode: 'コード取得',
    countdown: '{n}秒',
    confirmChange: '変更を確認',
    notAvailable: 'パスワード変更機能は現在利用できません。管理者にお問い合わせください。',
  },
  email: {
    currentEmail: '現在のメール：{email}',
    bound: '連携済み',
    newEmail: '新しいメールアドレス',
    newEmailPlaceholder: '新しいメールアドレスを入力',
    verifyCode: '認証コード',
    verifyCodePlaceholder: '認証コードを入力',
    getCode: 'コード取得',
    countdown: '{n}秒',
    confirmChange: '変更を確認',
    notAvailable: 'メール変更機能は現在利用できません。管理者にお問い合わせください。',
  },
}
